import { SessionSpeaker } from "./SessionData";

export interface session{
    Id: string,
    Title: string,
    Description: string,
    IsKeynote: boolean,
    VideoLink: string|undefined,
    IsWorkshop: boolean,
    EventId: string,
    VideoThumbnail: string|undefined;
    SessionSpeakers: SessionSpeaker[];
};

export function newSession():session{
    return{
        Id:"",
        Title:"",
        Description:"",
        IsKeynote:false,
        VideoLink:undefined,
        IsWorkshop:false,
        EventId:"",
        VideoThumbnail:undefined,
        SessionSpeakers: []
    }
};
export function newSessionArray():session[]{
    return [];
};